enum ProgramSource {
   ELIGIBILITY = "ELIGIBILITY",
   TRANSFORMED_CODE ="TRANSFORMED_CODE",
   PHARMACY_NETWORK = "PHARMACY_NETWORK",
   PRICING = "PRICING",
   PLAN = "PLAN",
   ACCUMS = "ACCUMS",
   PLAN_EDIT = "PLAN_EDIT",
   PRICING_GENAI_V2 = "PRICING_GENAI_V2",
   PHARMACY = "PHARMACY",
   PHARMACY_NETWORK_GENAI_V2 = "PHARMACY_NETWORK_GENAI_V2"
}

type programInformation = {
    programSource: ProgramSource;
    programParameters?: string[];
}

export type programInformations = {
    [name: string]: programInformation
}


export function convertDateForUrl(dateStr: string): string {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  const formattedDate = `${month}/${day}/${year}`;
  return encodeURIComponent(formattedDate); // e.g., "01%2F01%2F2001"
}


export function getProgramUrl(programName: string, parameters?: string[], tenantId? :string): string | undefined {
    // get program informations
    // @ts-ignore
    const pgm = (window as any)['navigation'][programName]
    // @ts-ignore
    const env = (window as any)["environments"];
    
 
      
    let url = undefined;
    // return program url
    if (pgm?.programSource === ProgramSource.ELIGIBILITY){
        let urlParameters = '';
        const urlKeys: string[] = pgm?.programParameters;
        if (parameters && parameters.length && parameters.length === urlKeys.length) {
            // TODO - move to environments.json
            const envMap = {
                'RXDV1_DEV': 'SXCD1',
                'RXCL1': 'CCTA',
                'RXCL4': 'SXCA2',
                'RXCL3': 'SXCA5',
                'RXCL2': 'SXCA6'
                };
            const encodedParameters: string[] = parameters.map((value, index) => urlKeys[index] + '=' + encodeURIComponent(value as string));
            if(tenantId !== undefined) {
                if (tenantId in envMap) {
                    encodedParameters.unshift('pid=' + envMap[tenantId as keyof typeof envMap]);
                }
            }

            encodedParameters.push('mode=edit');
            urlParameters = encodedParameters.length > 0 ? ";" + encodedParameters.join(";") : "";
        }
        const domain = env.eligibility
        const path = pgm?.programDestination;
        url = `${domain}member/${path}${urlParameters}`;
    }

    if (pgm?.programSource === ProgramSource.TRANSFORMED_CODE){
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        if(process.env.REACT_APP_PRESCRIBER_URL) {
            url = `${process.env.REACT_APP_PRESCRIBER_URL}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        } else {
            url = `${env.prescriberFrontend}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        }
    }

    if (pgm?.programSource === ProgramSource.PHARMACY_NETWORK){
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        if(process.env.REACT_APP_PHARMACY_NETWORK_URL) {
            url = `${process.env.REACT_APP_PHARMACY_NETWORK_URL}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        } else {
            url = `${env.pharmacyNetworkFrontend}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        }
    }

    if (pgm?.programSource === ProgramSource.PRICING){
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        if(process.env.REACT_APP_PRICING_URL) {
            url = `${process.env.REACT_APP_PRICING_URL}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        } else {
            url = `${env.pricingFrontend}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        }
    }

     if (pgm?.programSource === ProgramSource.PLAN){
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        if(process.env.REACT_APP_API_ENV === "local" || process.env.REACT_APP_API_ENV === "dev" || process.env.REACT_APP_API_ENV === "qa" || process.env.REACT_APP_API_ENV === "test" || process.env.REACT_APP_API_ENV === "stg") {
            url = `${env.planFrontendGenAI}/plan/program/${programName}${urlParameters}/?tenantId=${tenantId}`;
        } else {
            // url = `${process.env.REACT_APP_PHARMACY_NETWORK_URL}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        }
    }

    if (pgm?.programSource === ProgramSource.ACCUMS){
        if(process.env.REACT_APP_API_ENV === "dev" || process.env.REACT_APP_API_ENV === "qa") {
            url = `${env.accumsFrontendGenAI}`
        } else {
            url = `${env.accumsFrontendGenAI}`
        }
    }

    if (pgm?.programSource === ProgramSource.PLAN_EDIT){
        if(process.env.REACT_APP_API_ENV === "dev" || process.env.REACT_APP_API_ENV === "qa") {
            url = `${env.planEditFrontendGenAI}`
        } else {
            url = `${env.planEditFrontendGenAI}`
        }
    }

    if (pgm?.programSource === undefined){
        const encodedParameters: string[] = parameters && parameters.length > 0 ? parameters.map(elt=> encodeURIComponent(elt as string)) : [];
        const urlParameters = encodedParameters.length > 0 ? "/" + encodedParameters.join("/") : "";
        if(process.env.REACT_APP_API_ENV === "dev" || process.env.REACT_APP_API_ENV === "qa" || process.env.REACT_APP_API_ENV === "test" || process.env.REACT_APP_API_ENV === "stg" || process.env.REACT_APP_API_ENV === "local") {
            url = `${env.prescriberFrontend}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        } else {
            url = `${process.env.REACT_APP_PRESCRIBER_URL}/program/${programName}${urlParameters}/?tenantId=${tenantId}`
        }
    }

    // FIXME later : manage program source with presto and eligibility
    return url;
}

export function getAIProgramUrl(programName: string, parameters?: Record<string, any>, mediatorId?: string): string | undefined {
  const pgm = (window as any)['navigation'][programName];
  const env = (window as any)["environments"];

  if (!pgm || !env) return undefined;

  let url: string | undefined;
  if (pgm.programSource === ProgramSource.PLAN_EDIT) {
    url = `${env.planEditFrontendGenAI}${pgm.path}`;

    if (pgm.params && parameters) {
        const paramValues = pgm.params.map((paramKey: string) => {
        let value = parameters[paramKey];
   

        if (paramKey === 'planEffDate' && value) {
            value = convertDateForUrl(value);
        } else {
            value = encodeURIComponent(value ?? '');
        }

        return value;
    });

      url += `/${paramValues.join('/')}`;
    }
  }

  return url += mediatorId;
}

export function getUrl(programName: string): string | undefined {
  const pgm = (window as any)['navigation'][programName];
  const env = (window as any)["environments"];

  if (!pgm || !env) return undefined;

  let url: string | undefined;
  if (pgm.programSource === ProgramSource.PLAN_EDIT) {
    url = `${env.planEditFrontendGenAI}${pgm.path}`;
  } else if(pgm.programSource === ProgramSource.PRICING_GENAI_V2) {
    url = `${env.priceFrontendGenAIV2}${pgm.path}`;
  } else if (pgm.programSource === ProgramSource.PHARMACY) {
    url = `${env.pharmacyFrontendGenAI}${pgm.path}`;
  } else if (pgm.programSource === ProgramSource.ACCUMS) {
    url = `${env.accumsFrontendGenAI}${pgm.path}`;
  } else if (pgm.programSource === ProgramSource.PHARMACY_NETWORK_GENAI_V2) {
    url = `${env.pharmacyNetworkFrontendGenAIV2}${pgm.path}`;
  }
  return url;
}


